import React, { useState, useCallback } from "react";
import { memo } from "react";

// components
import { Checkbox, CHECKBOX_ACCENT, AriaHidden, useEffectOnce } from "@swiggy-private/core-ui";

// test-ids
import { NO_CONTACT_DELIVERY_OPT_IN_CHECKBOX } from "@swiggy-private/cart-test-ids";
import { CartGroupContainer, CartGroupTitle } from "@cart-ui/components/cart-group";

import styles from "./styles/CartCutleryInstruction.scss";

export interface CartCutleryInstructionProps {
    className?: string;
    onCheckChangeCallback?: (checked: boolean) => void;
    selected?: boolean;
    config: {
        title: string;
        preSelectionSubtitle: string;
        postSelectionSubtitle: string;
    };
    onImpressionCutleryShown: VoidFunction;
    onImpressionCutleryNotShown: VoidFunction;
}

const CUTLERY_INSTRUCTION_CHK_BOX = "CUTLERY_INSTRUCTION_CHK_BOX";

function CartCutleryInstruction(props: CartCutleryInstructionProps): React.ReactElement<CartCutleryInstructionProps> {
    const {
        selected = false,
        onCheckChangeCallback,
        config = { preSelectionSubtitle: "", postSelectionSubtitle: "", title: "" },
    } = props;

    const [checked, setChecked] = useState(selected);

    const onChangeCallback = useCallback(() => {
        setChecked(!checked);
        if (typeof onCheckChangeCallback === "function") {
            onCheckChangeCallback(!checked);
        }
    }, [checked, onCheckChangeCallback]);

    useEffectOnce(() => {
        selected ? props.onImpressionCutleryShown() : props.onImpressionCutleryNotShown();
    });

    return (
        <div
            role="checkbox"
            onClick={onChangeCallback}
            aria-checked={checked}
            data-testid={NO_CONTACT_DELIVERY_OPT_IN_CHECKBOX}
        >
            <CartGroupTitle title={"No-contact delivery"} />

            <CartGroupContainer>
                <div className={styles.contentSubtitle}>{config.preSelectionSubtitle}</div>
                <div className={styles.content}>
                    <AriaHidden as="div" className={styles.contentCheckbox}>
                        <Checkbox
                            checked={checked}
                            name={CUTLERY_INSTRUCTION_CHK_BOX}
                            value={CUTLERY_INSTRUCTION_CHK_BOX}
                            accent={CHECKBOX_ACCENT.SWIGGY_ORANGE}
                        />
                    </AriaHidden>
                    <div className={styles.contentTitle}>{config.title}</div>
                </div>
            </CartGroupContainer>
        </div>
    );
}

export default memo(CartCutleryInstruction);
